// Copied from 3rd party tool source code
// Source: https://github.com/ariakit/ariakit/blob/reakit%401.2.2/packages/reakit/src/Popover/__keys.ts
const POPOVER_STATE_KEYS = [
    'baseId',
    'unstable_idCountRef',
    'visible',
    'animated',
    'animating',
    'setBaseId',
    'show',
    'hide',
    'toggle',
    'setVisible',
    'setAnimated',
    'stopAnimation',
    'modal',
    'unstable_disclosureRef',
    'setModal',
    'unstable_referenceRef',
    'unstable_popoverRef',
    'unstable_arrowRef',
    'unstable_popoverStyles',
    'unstable_arrowStyles',
    'unstable_originalPlacement',
    'unstable_update',
    'placement',
    'place',
];
export const POPOVER_KEYS = POPOVER_STATE_KEYS;
export const POPOVER_ARROW_KEYS = [...POPOVER_KEYS, 'size'];
//# sourceMappingURL=__keys.js.map